import React from 'react';
import { Slide, Grid, Typography } from '@material-ui/core';

import Spacer from '../util/Spacer';
import useStyles from './Gastro.css';

const Gastro: React.FC = (): JSX.Element => {
  const classes = useStyles();
  return (
    <>
      <Slide in direction="down" timeout={500}>
        <div className={classes.hero} />
      </Slide>
      <div className={classes.root}>
        <Grid container>
          <Slide in direction="right" timeout={500}>
            <Grid item xs={12} md={7} className={classes.textAreaLeft}>
              <Typography
                variant="h6"
                color="primary"
                align="center"
                gutterBottom
              >
                Der perfekte Arbeitstag? Wenn die Mittagspause zum Genussmoment
                wird.
              </Typography>
              <Typography
                variant="body1"
                color="textSecondary"
                align="justify"
                gutterBottom
              >
                Ob Business-Lunch, Mittagessen mit Freunden oder entspannte
                Pause mit Freunden – bei uns stehen Qualität, Frische und
                Gastfreundschaft im Mittelpunkt. Unsere kleine, feine
                À-la-carte-Karte wird durch sechs abwechslungsreiche
                Mittagsmenüs ergänzt. Selbstverständlich finden Sie darunter
                auch vegetarische und vegane Gerichte. Dabei legen wir großen
                Wert auf frische Zutaten aus der Region und der jeweiligen
                Saison. Für noch mehr Abwechselung sorgen unser Suppen-, Salat-
                und Nachspeisenbuffet. Gleichzeitig sind uns effiziente Abläufe
                wichtig, damit Ihr Essen ohne lange Wartezeiten auf den Tisch
                kommt
              </Typography>
              <Spacer height={20} />
              <Typography
                variant="h6"
                color="primary"
                align="center"
                gutterBottom
              >
                Restaurantqualität – auch zum Mitnehmen.
              </Typography>
              <Typography
                variant="body1"
                color="textSecondary"
                align="justify"
                gutterBottom
              >
                Bestellen Sie Ihre Menüs ganz einfach vor und holen Sie sie zum
                gewünschten Zeitpunkt frisch zubereitet ab. Für den optimalen
                Transport werden alle Speisen in hochwertigen Thermoboxen
                verpackt. Auch Caterings bereiten wir gerne für Sie vor – diese
                können nach Vereinbarung bei uns abgeholt werden.
              </Typography>
              <Spacer height={20} />
            </Grid>
          </Slide>
          <Slide in direction="left" timeout={500}>
            <Grid item xs={12} md={5} className={classes.imgArea1} />
          </Slide>
          <Slide in direction="up" timeout={1000}>
            <Grid item xs={12} className={classes.priceHeading}>
              <Typography
                variant="h4"
                color="primary"
                align="center"
                gutterBottom
              >
                Informationen zu Allergenen
              </Typography>
            </Grid>
          </Slide>
          <Slide in direction="left" timeout={500}>
            <Grid item xs={12} className={classes.textAreaCenter}>
              <img
                src="/allergene.webp"
                alt="Die 14 Allergene - Übersicht: glutenhaltiges Getreide, Krebstiere, Eier, Fisch, Erdnüsse, Sojabohnen, Milch, Schalenfrüchte, Sellerie, Senf, Sesamsamen, Schwefeldioxid und Sulfite, Lupinen, Weichtiere"
                className={classes.allergenImage}
              />
            </Grid>
          </Slide>
          <Slide in direction="up" timeout={1000}>
            <Grid item xs={12} className={classes.priceHeading}>
              <Typography
                variant="h4"
                color="primary"
                align="center"
                gutterBottom
              >
                Informationspflicht zur Lebensmittelherkunft
              </Typography>
            </Grid>
          </Slide>
          <Slide in direction="left" timeout={500}>
            <Grid item xs={12} className={classes.textAreaCenter}>
              <Typography
                variant="body1"
                color="textSecondary"
                align="justify"
                gutterBottom
                style={{ whiteSpace: 'pre-line' }}
              >
                <a
                  href="/documents/Informationspflicht_Lebensmittelherkunft.pdf"
                  download
                >
                  Hier können Sie die Informationspflicht zur
                  Lebensmittelherkunft downloaden.
                </a>
              </Typography>
            </Grid>
          </Slide>
        </Grid>
      </div>
    </>
  );
};

export default Gastro;
